/**
 * How current the data on screen is (M7 §4), shared by Home (E6) and Positions (E8). Proposals,
 * provisional until Q3 and Q60. `offline` when a refresh got no response; `failed` follows the
 * reason text of a refresh the API refused. Each sentence with a time holds `{{time}}` exactly
 * once (`freshness.test.ts`): the indicator draws the time in `NUMERIC_FONT`.
 */
export const freshnessFr = {
  upToDate: 'À jour',
  refreshing: 'Actualisation…',
  updatedAt: 'Mis à jour à {{time}}',
  offline: 'Hors ligne : affichage du dernier état connu ({{time}}).',
  failed: 'Affichage du dernier état connu ({{time}}).',
};

/** Shape of the `freshness` section of `Messages`. */
export type FreshnessMessages = typeof freshnessFr;

/** English freshness texts. `FreshnessMessages` makes a missing or extra key a compile error (X5). */
export const freshnessEn: FreshnessMessages = {
  upToDate: 'Up to date',
  refreshing: 'Refreshing…',
  updatedAt: 'Updated at {{time}}',
  offline: 'Offline: showing the last known state ({{time}}).',
  failed: 'Showing the last known state ({{time}}).',
};
